export default function Policies() {
  return (
    <iframe
      title="policies"
      className="doc"
      src="https://docs.google.com/document/d/e/2PACX-1vQWTLIXFlwilWT4yQV0ApOEAPZIulQoHIzgLImFlCH3oX3O6LWr5vcObTA6E6LNAdirLc8JLhn_-FEr/pub?embedded=true"
    />
  )
}
